import Axios from 'axios';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react'
import NotData from '../../components/NotData';
import { useNavigate } from 'react-router-dom';
import { elapsedTime } from '../../common/howDate';
import BottomChat from './Components/BottomChat';

const Order_state = () => {

  const [books, setBooks] = useState([]);
  const columns = [
    'No', '메모', '사유', '처리', '처리시간', '브랜드', '분류', '제품이름', '탄방', '둔산', '자양', '충대', '확정수량'
  ];
  
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  
  const [ItemName, setItemName] = useState('');
  const [itemMemo, setItemMemo] = useState('');
  const [itemorderDate, setItemOrderDate] = useState('');
  const [itemCompletionDate, setItemCompletionDate] = useState('');

  // 시간 불러오는 부분
  let toDate = new dayjs().format('YYYY-MM-DD');
  let toTime = new dayjs().format('YYYY-MM-DD HH:mm:ss')

  const minusDate = (number)=>{
    const now = new dayjs().subtract(number, 'days');
    return now.format('YYYY-MM-DD');
  }

  const plusDate = (number)=>{
    const now = new dayjs().add(number, 'days');
    return now.format('YYYY-MM-DD');
  }

  const toDay = {
    date: toDate,
    time: toTime,
    minusDate,
    plusDate
  }

  // 데이터 리스트 불러오는 부분
  const loadeData = async ()=>{
    await Axios.get(`/api/order_state/orderstate/`, {
      params: { startDate: minusDate(7), endDate: toDay.date }
    })
    .then((res)=>{
      if(res.data.length)
      {
        setBooks(res.data);
      } else {
        setBooks([]);
      }
    })
  }

  // 날짜 및 바로 실행될 부분
  useEffect(()=>{
    document.title = '처리 완료';

    setStartDate(minusDate(7));
    setEndDate(toDay.date);

    // await Axios.get(`/api/order_order/orderitem_check`, {
    //   params: { itemIno: itemIno, itemName: ItemName }
    // })
    // .then((res)=>{
    //   if(res.data.value){ // 이미 요청목록에 제품이 있을때
    //     console.log('주문수정');
    //     orderItemUpdate(); // 해당 주문건 수정
    //   } else { // 요청 목록에 제품이 없을때
    //     orderItemAdd(); // 주문요청 실행 함수
    //     console.log('주문요청');
    //   }
    // });
    loadeData();
  }, [])

  // 주문 상태 조회 버튼
  const btnLoad = async ()=>{
    await Axios.get(`/api/order_state/orderstate/`, {
      params: { startDate, endDate }
    })
    .then((res)=>{
      if(res.data.length)
      {
        setBooks(res.data);
      } else {
        setBooks([]);
      }
      setSelectedRow(-1);
    })
  }

  // 셀렉트 테스트
  const [selectedRow, setSelectedRow] = useState(-1);

  const navigate = useNavigate();

    // 매장별 메모, 아이디 날짜
    const [memoDataTB, setMemoDataTB] = useState({});
    const [memoDataDS, setMemoDataDS] = useState({});
    const [memoDataJY, setMemoDataJY] = useState({});
    const [memoDataCD, setMemoDataCD] = useState({});
  
  return (
    <div className='p-3 flex flex-col gap-3 whitespace-nowrap'>
    <div className='flex justify-between items-center'>
      <ul className='flex gap-3'>
        <li className={`hover:underline cursor-pointer py-2 px-3 overflow-x-auto`} onClick={()=>navigate('/order/order')}>주문요청</li>
        <li className={`hover:underline cursor-pointer py-2 px-3 overflow-x-auto`} onClick={()=>navigate('/order/list')}>요청목록</li>
        <li className={`hover:underline cursor-pointer py-2 px-3 overflow-x-auto border-[1px] border-yellow-500 rounded-md`} onClick={()=>navigate('/order/state')}>처리완료</li>
      </ul>
      {/* <div>
        <button className='px-5 py-3 text-yellow-400'>새로고침</button>
      </div> */}
    </div>

    <div className='grid grid-cols-1 md:flex md:justify-between text-sm md:h-[calc(100vh-8.9rem)] gap-1'>

      <div className='flex flex-col justify-between gap-1 md:w-3/4 w-full'>

        {/* 메인 */}
        <div className='relative border-[1px] border-gray-500 w-full md:h-full h-[60vh] overflow-y-auto'>
          <table id='testTable' className='w-full'>
            <thead className='bg-[#1E1E1E]/90 whitespace-nowrap text-center sticky top-0 z-10'>
              <tr className='border-b-[1px] border-gray-500'>
                {columns.map((column) => (
                  <th className='p-3' key={column}>{column}</th>
                ))}
              </tr>
            </thead>
            <tbody className='text-center'>
              {
                books.length ?
                books.map((book, idx) => (
                  <tr className=
                  {`
                    duration-150 decoration-yellow-600 whitespace-nowrap active:scale-[0.98] active:opacity-80
                    ${selectedRow === idx ? 'bg-[#1E1E1E] font-bold underline decoration-[3px]' : 'even:bg-[#3E3E3E]'}
                  `}
                  key={idx} onClick={()=>{
                    setSelectedRow(idx);
                    setItemName(book.name);
                    setItemMemo(book.memo);
                    setItemOrderDate(book.date);
                    setItemCompletionDate(book.date_completion);

                    // 매장별 메모 데이터 받기
                    setMemoDataTB({ memo: book.memo_TB, id: book.TB_id, date: book.TB_date });
                    setMemoDataDS({ memo: book.memo_DS, id: book.DS_id, date: book.DS_date });
                    setMemoDataJY({ memo: book.memo_JY, id: book.JY_id, date: book.JY_date });
                    setMemoDataCD({ memo: book.memo_CD, id: book.CD_id, date: book.CD_date });

                    window.sessionStorage.setItem('select_copy', book.name);
                  }}>
                    <td className='p-2.5'>{idx + 1}</td>
                    <td className={`p-2.5 border-x-[1px] border-gray-500
                    ${(book.memo_TB || book.memo_DS || book.memo_JY || book.memo_CD) && 'animate-pulse'}
                    `}>
                      {(book.memo_TB || book.memo_DS || book.memo_JY || book.memo_CD) ? "📝" : "-"}
                    </td>
                    <td className={`p-2.5 border-x-[1px] border-gray-500 ${book.memo && 'animate-pulse'}`}>
                      {book.memo ? "📢" : "-"}
                    </td>
                    <td className='p-2.5 border-x-[1px] border-gray-500'>
                      <p className={`
                        px-2 py-1 rounded-sm ${book.step === '삭제' && 'bg-red-500/80'} ${book.step === '완료' && 'bg-blue-500/80'}
                      `}>{book.step}</p>
                    </td>
                    <td className={`p-2.5 border-x-[1px] border-gray-500 ${elapsedTime(book.date_completion) === '방금 전' && 'animate-pulse'}`}>
                      {elapsedTime(book.date_completion)}
                    </td>
                    <td className='p-2.5 border-x-[1px] border-gray-500'>{book.brand}</td>
                    <td className='p-2.5 border-x-[1px] border-gray-500'>{book.type}</td>
                    <td className='p-2.5 border-x-[1px] border-gray-500'>{book.name}</td>
                    <td className='p-2.5'>{
                    book.order_TB === 0 ? '-' : book.order_TB
                    }</td>
                    <td className='p-2.5'>{
                    book.order_DS === 0 ? '-' : book.order_DS
                    }</td>
                    <td className='p-2.5'>{
                    book.order_JY === 0 ? '-' : book.order_JY
                    }</td>
                    <td className='p-2.5'>{
                    book.order_CD === 0 ? '-' : book.order_CD
                    }</td>
                    <td className='p-2.5 border-l-[1px] border-gray-500 tracking-widest' style={{fontFamily: 'Gugi'}}>
                      {book.order_count}
                    </td>
                  </tr>
                ))
                :
                <tr className='relative'>
                  <td className='absolute w-full top-[30vh] left-auto'>
                    <NotData/>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>

       {/* 하단 판매금액 */}        
        <div className={`flex flex-col w-full overflow-x-auto overflow-y-hidden h-[25vh] md:h-64 border-[1px] border-gray-500`}>
          <div className="bg-[#0067BD] h-10 py-2 text-center">
            <p className="text-left pl-3 whitespace-nowrap">
              ※ 매장별 주문 요청 관련 참고사항
            </p>
          </div>

          <div className="flex h-full overflow-y-hidden overflow-x-auto bg-[#3E3E3E]">
            <div className={`flex whitespace-nowrap flex-auto justify-center items-center`}>
              {
                (!memoDataTB.memo && !memoDataDS.memo && !memoDataJY.memo && !memoDataCD.memo) ?
                <div className=''>
                  <p className='text-base tracking-wide duration-150 animate-pulse' style={{fontFamily: 'Gugi'}}>메모를 남긴 매장이 없습니다</p>
                </div>
                :
                <>
                  <BottomChat store={ '탄방점' } data={ { memo: memoDataTB.memo, id: memoDataTB.id, date: memoDataTB.date } }/>
                  <BottomChat store={ '둔산점' } data={ { memo: memoDataDS.memo, id: memoDataDS.id, date: memoDataDS.date } }/>
                  <BottomChat store={ '자양점' } data={ { memo: memoDataJY.memo, id: memoDataJY.id, date: memoDataJY.date } }/>
                  <BottomChat store={ '충대점' } data={ { memo: memoDataCD.memo, id: memoDataCD.id, date: memoDataCD.date } }/>
                </>
              }
            </div>
          </div>
        </div>

      </div>

      {/* 사이드 */}
      <div className='md:w-1/4 w-full md:overflow-y-auto bg-[#424242] border-[1px] border-gray-500'>
          <div className='bg-[#0067BD] py-2 text-center'>
            <p className='text-left pl-3'>
              ※ 제품 주문 요청
            </p>
          </div>

          <div className='p-3 flex flex-col gap-2'>

            {/* 날짜 조회 */}
            <div className='grid lg:grid-cols-2 gap-2'>
              <div className='w-full'>
                <p>시작 날짜</p>
                <input id='dateInput' type='date' className='w-full mt-1 h-12 bg-[#2E2E2E] p-2 px-2 rounded-md outline-none border-[1px] border-gray-400' value={startDate} onChange={(e)=>setStartDate(e.target.value)} />
              </div>    
              <div className='w-full'>
                <p>종료 날짜</p>
                <input id='dateInput' type='date' className='w-full mt-1 h-12 bg-[#2E2E2E] p-2 px-2 rounded-md outline-none border-[1px] border-gray-400' value={endDate} onChange={(e)=>setEndDate(e.target.value)} />
              </div>              
            </div>

            {/* 언더라인 */}
            <div className='border-b-[1px] border-gray-400 py-1'></div>
            
            {/* 주문 상태 조회 버튼 */}
            <div className='flex flex-col gap-2 pt-2'>
              <button className='bg-[#2E2E2E] h-12 w-[100%] rounded-sm text-center border-[1px] border-yellow-500/80 duration-150 hover:scale-[0.98] active:border-none' onClick={btnLoad} >
                주문 상태 조회
              </button>
            </div>

            {/* 제품이름 */}
            <div className='w-full'>
              <p>제품 이름</p>
              <input className='bg-[#2E2E2E] mt-2 rounded-t-md w-full h-[70px] text-center font-bold border-b-[1px] hover:border-blue-500 border-gray-400' placeholder='〈 제품을 선택하세요 〉' disabled type='text' value={ItemName}/>
            </div>

            <div className='flex flex-col gap-2 w-full'>
              <div className='flex justify-between'>
                <p className=''>처리 사유</p>
                <button className='px-2 text-yellow-400' onClick={()=>alert('텍스트박스 우측 하단을 드래그시 창을 늘리거나 축소 할 수 있습니다.')}>
                  펼치기
                </button>
              </div>
              <div className='flex flex-col justify-center items-center'>
                <textarea disabled placeholder='〈 제품을 선택하세요 〉' className={`w-full text-center h-[70px] outline-none bg-[#2E2E2E] rounded-md ml-5 mr-5 p-3 duration-150 ${itemMemo && 'bg-red-500/60'}`} type='text' value={!itemMemo ? '없음' : itemMemo} onChange={(e)=>{
                  setItemMemo(e.target.value);
                }} />
              </div>
            </div>

            {/* 처리 날짜 */}
            <div className='flex flex-col justify-center gap-3'>
              <p>요청 날짜</p>
              <input className='bg-[#2E2E2E] h-12 rounded-md text-center' disabled type='text' placeholder='〈 제품을 선택하세요 〉' value={itemorderDate} />
            </div>

            {/* 판매 날짜 */}
            <div id='priceText' className='flex flex-col justify-center gap-3'>
              <p>처리 날짜</p>
              <input className='bg-[#2E2E2E] h-12 rounded-md text-center' disabled type='text' placeholder='〈 제품을 선택하세요 〉' value={itemCompletionDate} />
            </div>

          </div>
      </div>

    </div>

  </div>
  )
}

export default Order_state